import React from 'react';
import Container from 'components/container';
import PublicLayout from 'components/layouts/Public';
import { PROJECTS_URL } from 'constants/urls';
import BlogFeed from 'containers/blog/feed';
import { projectsFeedItems } from 'content/projects';

const ProjectsPage = () => {
  return (
    <PublicLayout title="Projects">
      <Container centerContent py="20px" pylg="20px">
        <BlogFeed feedItems={projectsFeedItems} path={PROJECTS_URL} />
      </Container>
    </PublicLayout>
  );
};

export default ProjectsPage;
